import type { User, Session } from '@supabase/supabase-js';

/**
 * Vérifie si l'application est en mode démo
 * Le mode démo est activé si :
 * - La variable d'environnement VITE_DEMO_MODE est 'true'
 * - L'URL contient le paramètre ?demo=1
 * - Le chemin contient /auth/demo
 */
export const isDemoMode = (): boolean => {
  // PRODUCTION LOCKOUT: Never allow demo mode in production
  // This is a critical security measure to prevent demo mode abuse
  if (import.meta.env.PROD) {
    return false;
  }
  
  // Only allow in DEV environment
  try {
    if (import.meta.env.VITE_DEMO_MODE === 'true') {
      return true;
    }
  } catch {
    // ignore
  }
  if (typeof window === 'undefined') return false;
  
  return window.location.search.includes('demo=1') || 
         window.location.pathname.includes('/auth/demo');
};

/**
 * Assure que le paramètre ?demo=1 reste présent dans l'URL quand le mode démo est actif
 * À appeler dans les composants qui doivent maintenir le mode démo
 */
export const ensureDemoParameter = (): void => {
  if (typeof window === 'undefined') return;
  
  if (isDemoMode() && !window.location.search.includes('demo=1')) {
    const url = new URL(window.location.href);
    url.searchParams.set('demo', '1');
    window.history.replaceState({}, '', url.toString());
  }
};

/**
 * Utilisateur démo avec des données fictives
 */
export const DEMO_USER: Partial<User> = {
  id: 'demo-user-id-123',
  email: 'demo@nocodeo.com',
  user_metadata: {
    first_name: 'Compte',
    last_name: 'Démo',
    role: 'admin_entreprise',
  },
  aud: 'authenticated',
  role: 'authenticated',
  created_at: new Date().toISOString(),
};

/**
 * Crée une session démo fictive
 */
export const createDemoSession = (): Partial<Session> => ({
  access_token: 'demo-access-token',
  token_type: 'bearer',
  expires_in: 3600,
  expires_at: Math.floor(Date.now() / 1000) + 3600,
  refresh_token: 'demo-refresh-token',
  user: DEMO_USER as User,
});
